import type { ICellRendererParams } from 'ag-grid-community';
import { formatDate } from '@utils/format';
import type { Closure } from '../../schema';

/**
 * Two-line cell:
 *   primary  → date range (single-day) or "<start> – <end>" (range)
 *   muted    → human duration ("3 days") or "single day"
 */
export function DateRangeCell(p: ICellRendererParams<Closure>) {
  if (!p.data) return null;
  const { startDate, endDate } = p.data;
  const isSingleDay = startDate === endDate;

  const startMs = Date.parse(startDate);
  const endMs = Date.parse(endDate);
  const days = Number.isFinite(startMs) && Number.isFinite(endMs)
    ? Math.round((endMs - startMs) / 86_400_000) + 1
    : 0;

  return (
    <div className="flex flex-col leading-tight">
      <span className="text-[13px] font-semibold text-foreground">
        {isSingleDay
          ? formatDate(startDate)
          : `${formatDate(startDate)} – ${formatDate(endDate)}`}
      </span>
      <span className="mt-0.5 text-[11px] text-foreground-muted">
        {isSingleDay ? 'Single day' : `${days} days`}
      </span>
    </div>
  );
}
